// Filename - components/SidebarData.js

import React from "react";
import MasterIcon from "../../globalStyles/icons/master-icon";
import ClientIcon from "../../globalStyles/icons/client-icon";
import ProductIcon from "../../globalStyles/icons/product-icon";
import PortIcon from "../../globalStyles/icons/port-icon";
import ZoneIcon from "../../globalStyles/icons/zone-icon";
import CarrierIcon from "../../globalStyles/icons/carrier-icon";
import ServiceIcon from "../../globalStyles/icons/service-icon";
import ZipZoneIcon from "../../globalStyles/icons/zipZone-icon";
import RateCardIcon from "../../globalStyles/icons/rateCard-icon";
import ToolIcon from "../../globalStyles/icons/tools-icon";
import PortLookUpIcon from "../../globalStyles/icons/portLookup-icon";
import RateLookUpIcon from "../../globalStyles/icons/rateLookup-icon";
import SimulationIcon from "../../globalStyles/icons/simulation-icon";
import DashboardIcon from "../../globalStyles/icons/dashboard-icon";
import WarehouseIcon from "../../globalStyles/icons/warehouse-icon";
import OrderIcon from "../../globalStyles/icons/order-icon";
import ShipmentIcon from "../../globalStyles/icons/shipment-icon";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import StormIcon from "@mui/icons-material/Storm";
import TransactionIcon from "../../globalStyles/icons/transaction-icon";
import PartnerIcon from "../../globalStyles/icons/partner-icon";
import CustomClearanceIcon from "../../globalStyles/icons/custom-clearance-icon";
import FreightBrokerIcon from "../../globalStyles/icons/freightbrokerIcon";
import CustomProviderIcon from "../../globalStyles/icons/CustomProviderIcon";
import ShipmentCostIcon from "../../globalStyles/icons/shipmentCostIcon";
import PackageMappingIcon from "../../globalStyles/icons/packageMappingIcon";
import SupplierIcon from "../../globalStyles/icons/supplier-icon";
import BillingIcon from "../../globalStyles/icons/billing-icon";
import AlertIcon from "../../globalStyles/icons/alert-icon";
import AnalyticsIcon from "../../globalStyles/icons/analytics-icon";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import HubIcon from "@mui/icons-material/Hub";
import ControlPanelIcon from "../../globalStyles/icons/control-panel-icon";
import CommandCenterIcon from "../../globalStyles/icons/command-center-icon";
import POSIcon from "../../globalStyles/icons/pos-icon";
import CustomerIcon from "../../globalStyles/icons/customer-icon";
import GenerateCartIcon from "../../globalStyles/icons/generate-cart-icon";
import DefaultIcon from "../../globalStyles/icons/default-icon";

export const getIcon = (iconName, fill, height, width, title = "") => {
  switch (iconName) {
    case "MasterIcon":
      return <MasterIcon fill={fill} height={height} width={width} />;
    case "ClientIcon":
      return <ClientIcon fill={fill} />;
    case "ProductIcon":
      return <ProductIcon fill={fill} />;
    case "PortIcon":
      return <PortIcon fill={fill} />;
    case "ZoneIcon":
      return <ZoneIcon fill={fill} />;
    case "CarrierIcon":
      return <CarrierIcon fill={fill} />;
    case "ServiceIcon":
      return <ServiceIcon fill={fill} />;
    case "ZipZoneIcon":
      return <ZipZoneIcon fill={fill} />;
    case "RateCardIcon":
      return <RateCardIcon fill={fill} />;
    case "ToolIcon":
      return <ToolIcon fill={fill} />;
    case "PortLookUpIcon":
      return <PortLookUpIcon fill={fill} />;
    case "RateLookUpIcon":
      return <RateLookUpIcon fill={fill} />;
    case "SimulationIcon":
      return <SimulationIcon fill={fill} />;
    case "DashboardIcon":
      return <DashboardIcon fill={fill} />;
    case "WarehouseIcon":
      return <WarehouseIcon fill={fill} />;
    case "OrderIcon":
      return <OrderIcon fill={fill} />;
    case "ShipmentIcon":
      return <ShipmentIcon fill={fill} />;
    case "CatalogueIcon":
      return <DesignServicesIcon fill={fill} />;
    case "ForecastIcon":
      return <StormIcon fill={fill} />;
    case "TransactionIcon":
      return <TransactionIcon fill={fill} />;
    case "PartnerIcon":
      return <PartnerIcon fill={fill} />;
    case "CustomClearanceIcon":
      return <CustomClearanceIcon fill={fill} />;
    case "CustomProviderIcon":
      return <CustomProviderIcon fill={fill} />;
    case "FreightBrokerIcon":
      return <FreightBrokerIcon fill={fill} />;
    case "ShipmentCostIcon":
      return <ShipmentCostIcon fill={fill} />;
    case "PackageMappingIcon":
      return <PackageMappingIcon fill={fill} />;
    case "SupplierIcon":
      return <SupplierIcon fill={fill} />;
    case "BillingIcon":
      return <BillingIcon fill={fill} />;
    case "AlertIcon":
      return <AlertIcon fill={fill} />;
    case "AnalyticsIcon":
      return <AnalyticsIcon fill={fill} />;
    case "EventIcon":
      return <EventNoteOutlinedIcon fill={fill} />;
    case "ChatBot":
      return <SmartToyIcon sx={{ color: fill }} />;
    case "AdminPanelSettingsIcon":
      return <AdminPanelSettingsIcon sx={{ color: fill }} />;
    case "HistoricalIcon":
      return <SettingsBackupRestoreIcon fill={fill} />;
    case "NetworkDesignIcon":
      return <HubIcon fill={fill} />;
    case "ControlPanelIcon":
      return <ControlPanelIcon fill={fill} />;
    case "CommandCenterIcon":
      return <CommandCenterIcon fill={fill} />;
    case "POSIcon":
      return <POSIcon fill={fill} />;
    case "CustomerIcon":
      return <CustomerIcon fill={fill} />;
    case "GenerateCartIcon":
      return <GenerateCartIcon fill={fill} />;
    default:
      return (
        <DefaultIcon fill={fill} height={height} width={width} title={title} />
      );
  }
};
